import React from "react";
import { ApiService } from "../services";
import { useSnackbar } from "react-simple-snackbar";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import FormikControl from "../formikComponents/formikControl";
import GButton from "../gComponents/gButton";

export default function CreatDocType(props) {
  const [openSnackbar] = useSnackbar();

  const initialValues = {
    user_type: props.type ? props.type : "",
    title: !props.isEmpty ? props.data.title : "",
    type: !props.isEmpty ? props.data.type : "",
    status: !props.isEmpty ? props.data.status : 1,
  };

  const onSubmit = (values) => {
    console.log(values);

    var hitMethod = !props.isEmpty ? "PUT" : "POST";
    var hitUrl = !props.isEmpty
      ? "document/types/" + props.data.id
      : "document/types";
    ApiService({ method: hitMethod, route: hitUrl, body: values }).then(
      (response) => {
        console.log("r" + response.data.status_code);
        if (response.data.status_code === 1) {
          props.setDtvisible(false);
          props.onSubmit(response.data.data);
        }
        openSnackbar(response.data.message);
        return;
      }
    );
  };

  const validationSchema = Yup.object({
    title: Yup.string().required("Required"),
  });

  if (props.dtvisible === false) {
    return null;
  }
  return (
    <>
      <div className="modal-header">
        {!props.isEmpty ? "Edit" : "Create"} Document Type
      </div>
      <div className="modal-body">
        <Formik
          initialValues={initialValues}
          onSubmit={onSubmit}
          validationSchema={validationSchema}
        >
          {({ values, setFieldValue }) => (
            <Form>
              <FormikControl
                control="input"
                type="text"
                label="Title"
                name="title"
              />
              <FormikControl
                control="radio"
                label="Type"
                name="type"
                options={[
                  { key: "Image", value: "image" },
                  { key: "Text", value: "text" },
                ]}
                key_title="key"
                key_value="value"
                divstyle={{ display: "block", padding: "5px 0" }}
              />
              <FormikControl
                control="toggle"
                label="Status"
                isToggled={values.status}
                name="status"
                onToggle={() => {
                  setFieldValue("status", values.status == 1 ? 0 : 1);
                }}
              />
              <br />
              <br />

              <GButton
                type="submit"
                variant="condensed"
                children={!props.isEmpty ? "Update" : "Create"}
                style={{ margin: "0 15px", width: "calc(100% - 30px)" }}
              />
            </Form>
          )}
        </Formik>
      </div>
    </>
  );
}
